import Splide from '@splidejs/splide';
import Utils from '../Utils';

const ImageCarousel = {
    init() {
        this.sliders = [];
        document.querySelectorAll('[data-image-carousel]').forEach((root) => {
            const dom = this.cacheDom(root);
            if (dom) {
                this.sliders.push(this.createSlider(dom));
                this.observeCaptionSpace(dom);
            }
        });
    },

    cacheDom(root) {
        const slider = root.querySelector('[data-image-carousel-slider]');
        if (!slider) return null;

        return {
            root,
            slider,
            prev: root.querySelector('[data-image-carousel-prev]'),
            next: root.querySelector('[data-image-carousel-next]'),
        };
    },

    createSlider(dom) {
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const slideCount = dom.slider.querySelectorAll('.splide__slide').length;
        const canLoop = slideCount >= 2;

        const splide = new Splide(dom.slider, {
            type: canLoop ? 'loop' : 'slide',
            perPage: 1,
            pagination: false,
            arrows: false,
            speed: reduceMotion ? 0 : 500,
            drag: !reduceMotion && canLoop,
            i18n: {
                prev: 'Previous',
                next: 'Next',
            },
        });

        splide.on('mounted', () => this.measureCaptionSpace(dom));
        splide.on('resized', () => this.measureCaptionSpace(dom));

        if (dom.prev) {
            dom.prev.addEventListener('click', () => splide.go('<'));
        }
        if (dom.next) {
            dom.next.addEventListener('click', () => splide.go('>'));
        }

        splide.mount();
        return splide;
    },

    measureCaptionSpace(dom) {
        const captions = dom.slider.querySelectorAll('.image-carousel__caption');
        const minHeight = 80;
        let max = 0;

        captions.forEach((caption) => {
            caption.style.minHeight = '0px';
            max = Math.max(max, caption.offsetHeight);
            caption.style.minHeight = '';
        });

        max = Math.max(max, minHeight);
        dom.slider.style.setProperty('--caption-space', `${max}px`);
    },

    observeCaptionSpace(dom) {
        const update = Utils.debounce(() => this.measureCaptionSpace(dom), 100);
        const observer = new ResizeObserver(update);

        observer.observe(dom.slider);

        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(() => this.measureCaptionSpace(dom));
        }
    },
};

export default ImageCarousel;
